import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { UnansweredQuestionsService } from './unansweredQuestionsApi';
import { IUnansweredQuestionsListState } from '../../../../interfaces/unanswered-questions/IUnansweredQuestionsListState';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';

const initialState: IUnansweredQuestionsListState = {
    questionsAreLoading: false,
    questionIsLoading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToFetchAllUnansweredQuestions = createAsyncThunk<any, any>(
    'questions/tryToFetchAllUnansweredQuestions',
    async (data: any) => {
        const result = await UnansweredQuestionsService.tryToFetchAllUnansweredQuestions(data);
        return result?.data;
    }
);

export const tryToFetchUnansweredQuestions = createAsyncThunk<any, IPaginationPayload>(
    'questions/tryToFetchUnansweredQuestions',
    async ({ pageNumber, pageSize, filters, data }) => {
        const result = await UnansweredQuestionsService.tryToFetchUnansweredQuestions(
            pageNumber,
            pageSize,
            data,
            filters,
        );
        return result;
    },
);

export const tryToFetchSingleUnansweredQuestion = createAsyncThunk<any, string>(
    'questions/tryToFetchSingleUnansweredQuestion',
    async (id) => {
        const result = await UnansweredQuestionsService.tryToFetchSingleUnansweredQuestion(id);
        return result?.data;
    }
);


export const tryToFetchUnansweredQuestionStats = createAsyncThunk<any, undefined>(
    'questions/tryToFetchUnansweredQuestionStats',
    async () => {
        const result = await UnansweredQuestionsService.tryToFetchUnansweredQuestionStats();
        return result?.data;
    }
);

export const questionsSlice = createSlice({
    name: 'questions',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // tryToFetchAllUnansweredQuestions
            .addCase(tryToFetchAllUnansweredQuestions.pending, (state) => {
                state.questionsAreLoading = true;
            })
            .addCase(tryToFetchAllUnansweredQuestions.rejected, (state) => {
                state.questionsAreLoading = false;
            })
            .addCase(tryToFetchAllUnansweredQuestions.fulfilled, (state, action) => {
                state.questionsAreLoading = false;
                state.allQuestions = action.payload;
            })

            // tryToFetchUnansweredQuestions
            .addCase(tryToFetchUnansweredQuestions.pending, (state) => {
                state.questionsAreLoading = true;
            })
            .addCase(tryToFetchUnansweredQuestions.rejected, (state) => {
                state.questionsAreLoading = false;
            })
            .addCase(tryToFetchUnansweredQuestions.fulfilled, (state, action) => {
                state.questionsAreLoading = false;
                state.questions = action.payload;
            })

            // tryToFetchSingleUnansweredQuestion
            .addCase(tryToFetchSingleUnansweredQuestion.pending, (state) => {
                state.questionIsLoading = true;
            })
            .addCase(tryToFetchSingleUnansweredQuestion.rejected, (state) => {
                state.questionIsLoading = false;
            })
            .addCase(tryToFetchSingleUnansweredQuestion.fulfilled, (state, action) => {
                state.questionIsLoading = false;
                state.question = action.payload;
            })

    },
});

export default questionsSlice.reducer;